import "./Loading.css";
import PropTypes from "prop-types";
import { LOADER_ACCENT_COLOR } from "common/Components/Loader/Loader.style";

export default function Loading({
  loadingText = "Loading...",
  color = LOADER_ACCENT_COLOR,
}) {
  return (
    <div className="loading-spinner">
      <div className="spinner" style={{ borderLeftColor: color }} />
      <p className="spinnerText" style={{ color }}>{loadingText}</p>
    </div>
  );
}
Loading.propTypes = {
  loadingText: PropTypes.string,
  color: PropTypes.string,
};
